// ═══════════════════════════════════════════════════════════════════════
// theme.js — Single source of truth for colors, fonts, spacing
// ═══════════════════════════════════════════════════════════════════════
// Eliminates the 12× duplication of `const T = { ... }` across tab files.
// Import: `import { T, FONTS, pill, SECTION_TITLE } from "./theme";`
// ═══════════════════════════════════════════════════════════════════════

export const T = {
  // backgrounds
  bg:    "#030912",
  bg2:   "#050f1e",
  bg3:   "#081525",
  bg4:   "#0c1c30",
  bg5:   "#101f35",

  // accents
  cyan:   "#00e5ff",
  green:  "#00ff88",
  amber:  "#ffb300",
  gold:   "#ffd600",
  purple: "#c084fc",
  pink:   "#ff4f8b",
  blue:   "#38a8ff",
  teal:   "#00d4c0",
  red:    "#ff4444",
  orange: "#fb923c",
  steel:  "#64b5d6",

  // text
  text:  "#ddeeff",
  text2: "#6a8fa8",
  text3: "#2e4a60",

  // borders
  border:  "rgba(0,229,255,.1)",
  border2: "rgba(255,255,255,.05)",

  // semantic aliases (kept for tabs that use semantic naming)
  success: "#00ff88",
  warning: "#ffb300",
  error:   "#ff4444",
  info:    "#00e5ff",
};

export const FONTS = {
  header: "'Orbitron', monospace",
  mono:   "'Share Tech Mono', monospace",
  body:   "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
  code:   "'Fira Code', 'Cascadia Code', Consolas, monospace",
};

// Reusable component-level style helpers
export const pill = (c) => ({
  display: "inline-block",
  padding: "1px 7px",
  borderRadius: 10,
  fontSize: 8,
  fontFamily: FONTS.mono,
  background: `${c}15`,
  color: c,
  border: `1px solid ${c}40`,
});

export const selectStyle = {
  background: T.bg3,
  border: `1px solid ${T.border}`,
  color: T.text,
  padding: "5px 8px",
  borderRadius: 4,
  fontSize: 9.5,
  outline: "none",
  cursor: "pointer",
};

export const inputStyle = {
  background: T.bg3,
  border: `1px solid ${T.border}`,
  color: T.text,
  padding: "5px 10px",
  borderRadius: 4,
  fontSize: 10,
  outline: "none",
};

export const cardStyle = {
  background: T.bg2,
  border: `1px solid ${T.border}`,
  borderRadius: 8,
  padding: "12px 14px",
};

export const sectionTitleStyle = (color) => ({
  fontSize: 9,
  fontFamily: FONTS.mono,
  color: color,
  fontWeight: 700,
  letterSpacing: 1.5,
  marginBottom: 8,
  textTransform: "uppercase",
});

// Common chip / button factory
export const chipBtn = (active, color) => ({
  padding: "5px 12px",
  fontSize: 10,
  borderRadius: 4,
  cursor: "pointer",
  background: active ? `${color}15` : T.bg3,
  border: `1px solid ${active ? color : T.border}`,
  color: active ? color : T.text2,
  fontFamily: FONTS.mono,
  fontWeight: active ? 700 : 400,
  letterSpacing: 1,
});
